import styled from 'styled-components'

export const AppContainer = styled.div`
  height: 100vh;
  background-color: #eef4f7;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

export const Heading = styled.h1`
  font-size: 30px;
  color: #334155;
  font-family: 'Roboto';
  padding-bottom: 5px;
  font-weight: 900;
  border-bottom: 4px solid #52bbf0;
`
export const ListOfPackages = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style-type: none;
  padding: 0px;
`
export const List = styled.li`
  width: 400px;
  margin: 20px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
`

export const Image = styled.img`
  width: 100%;
`
export const ListText = styled.div`
  padding: 10px;
`
export const ListHead = styled.h1`
  font-size: 20px;
  font-family: 'Roboto';
  color: #475569;
  font-weight: 900;
`
export const ListPara = styled.p`
  font-size: 18px;
  font-family: 'Roboto';
  color: #64748b;
  font-weight: 500;
`
